import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitScore = async (game, score) => {
  try {
    const { data } = await axios.post(`${API}/games/score`, { game, score: Math.round(score) }, { withCredentials: true });
    return data;
  } catch (error) {
    return null;
  }
};

export const fetchLeaderboard = async (game) => {
  const { data } = await axios.get(`${API}/games/leaderboard/${game}`, { withCredentials: true });
  return data;
};

export const sendAiGameMessage = async (gameType, sessionId, message) => {
  const { data } = await axios.post(
    `${API}/games/ai-chat`,
    { game_type: gameType, session_id: sessionId, message },
    { withCredentials: true }
  );
  return data.reply;
};

export const resetAiGame = async (gameType, sessionId) => {
  await axios.post(
    `${API}/games/ai-chat/reset`,
    { game_type: gameType, session_id: sessionId, message: 'reset' },
    { withCredentials: true }
  );
};
